module.exports = __webpack_public_path__ + "9ebc2e16f1970c875a4471429b510b85.svg";